class DynamicAccordion extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.toggleAccordion);
  }

  connectedCallback() {
    if (this.hasAttribute('open')) {
      this.openAccordion();
    }
  }

  toggleAccordion(event) {
    const button = event.target.closest('[data-accordion-button]');
    if (!button) return;

    this._toggle(button);
  }

  openAccordion() {
    const button = this.querySelector('[data-accordion-button]');
    if (button) {
      this._toggle(button, true);
    }
  }

  _toggle(button, forceOpen) {
    const isActive = button.classList.contains('active');
    if (forceOpen && isActive) return;

    button.classList.toggle('active', !isActive || forceOpen);
    const description = button.nextElementSibling;

    if (description && description.hasAttribute('data-accordion-description')) {
      description.classList.toggle('opened', !isActive || forceOpen);

      const maxHeight = description.scrollHeight + 24

      if (description.style.maxHeight && !forceOpen) {
        description.style.maxHeight = null;
      } else {
        description.style.maxHeight = maxHeight + 'px';
      }
    }
  }
}

customElements.define('dynamic-accordion', DynamicAccordion);